import item_0 from '../image/index-item-meishi-0.png'
import item_1 from '../image/index-item-chaoshi-1.png'
import item_2 from '../image/index-item-shengxian-2.png'
import item_3 from '../image/index-item-zhuansong-3.png'
import item_4 from '../image/index-item-kuaican-4.png'
import item_5 from '../image/index-item-cha-5.png'
import item_6 from '../image/index-item-hanbao-6.png'
import item_7 from '../image/index-item-cai-7.png'
import item_8 from '../image/index-item-xiaochi-8.png'
import item_9 from '../image/index-item-xianhua-9.png'

const itemData = {
    url: '/index/item',
    res: {
        data: [
            {
                name: '美食',
                img: item_0
            },
            {
                name: '美团超市',
                img: item_1
            },
            {
                name: '生鲜果蔬',
                img: item_2
            },
            {
                name: '美团专送',
                img: item_3
            },
            {
                name: '快食简餐',
                img: item_4
            },
            {
                name: '下午茶',
                img: item_5
            },
            {
                name: '汉堡披萨',
                img: item_6
            },
            {
                name: '家常菜',
                img: item_7
            },
            {
                name: '小吃馆',
                img: item_8
            },
            {
                name: '鲜花蛋糕',
                img: item_9
            },
        ]
    }
}

export default itemData